import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import Api from "@/services/api/ApiServiceFabrick"
import { Ref, ref, watch, onMounted } from 'vue'
import { firstFile } from '@/services/functions'


export default /*@__PURE__*/_defineComponent({
  __name: 'ImagethumbnailDisplay',
  props: {
    image: {},
    newImage: {},
    modelName: {},
    modelId: {}
  },
  setup(__props: any) {

const props = __props

const url: Ref<string | null> = ref(null)

function getUrl() {
  if (!props.image || !props.modelId) return
  Api().getFileUrl(props.modelName, props.modelId).then((data) => {
    url.value = data
  })
}

function getFileUrl(file: any) {
  if (!file) return
  return URL.createObjectURL(file);
}

onMounted(() => {
  getUrl()
})

return (_ctx: any,_cache: any) => {
  return (_unref(firstFile)(props.newImage))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: getFileUrl(_unref(firstFile)(props.newImage)),
        width: "300"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (url.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: url.value,
              width: "300"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
}
}

})